import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminRSVPs from "@/pages/AdminRSVPs";
import Gallery from "@/pages/Gallery";
import AdminGallery from "@/pages/AdminGallery";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admin/rsvps" element={<AdminRSVPs />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#FDFBF7",
            fontFamily: "'Manrope', sans-serif",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
